import { Injectable, OnDestroy } from '@angular/core';

import { RidangoEpic } from '@ridango/core';

import { PlannerEpics } from './planner/planner.epic';
import { OnDemandTripsEpics } from './ondemand-trips/ondemand-trips.epic';
import { RouteStopsEpics } from './route-stops/route-stops.epic';
import { RouteTripEpics } from './route-trip/route-trip.epic';
import { RoutesEpics } from './routes/routes.epic';

@Injectable()
export class ScheduleEpics implements RidangoEpic {
    constructor(
        private routesEpics: RoutesEpics,
        private routeStopsEpics: RouteStopsEpics,
        private routeTripEpics: RouteTripEpics,
        private plannerEpics: PlannerEpics,
        private onDemandTripsEpics: OnDemandTripsEpics,
    ) {}

    register() {
        return [].concat(
            this.routesEpics.register(),
            this.routeStopsEpics.register(),
            this.routeTripEpics.register(),
            this.plannerEpics.register(),
            this.onDemandTripsEpics.register(),
        );
    }
}
